<template>
  <UiCol cols="auto" class="pa-2">
    <RouterLink :to="src" class="text-decoration-none">
      <slot />
    </RouterLink>
  </UiCol>
</template>

<script setup lang="ts">
import UiCol from '../UiCol/UiCol.vue';
import { RouterLink } from '~/infrastructure';

export interface Props {
  src: string;
}

defineProps<Props>();
</script>
